import { Div, Text, Image, Link, Span, Paragraph, ModalWindow, JsonViewer, MultilineInput, RefSerializer } from "@tblabs/truffle";
import { BasketItem } from "../../../../../../Models/Basket/BasketItem";
import { TableEntry } from "./TableEntry";
import { RentBasketItem } from "../../../../../../Models/Basket/RentBasketItem";
import { TimeUtils } from "../../../../../../Utils/TimeUtils";


export class AdminBasketTableItem extends TableEntry
{
    constructor(item: BasketItem)
    {
        const dates = (item instanceof RentBasketItem) ? TimeUtils.FormattedRange(item.From, item.To) : "";

        super({
            Content: [
                new Div("basket-cart-item").Append(
                    new Image(item.ProductInfo.Picture, item.ProductInfo.Name).Class("basket-cart-item-image"),
                    new Div("basket-cart-item-details").Append(
                        new Link(item.ProductInfo.Name, item.ProductInfo.Link),
                        item.Quantity.value > 1 && new Span(`×${item.Quantity.value}`).MarginLeft(8),
                        new Div("basket-cart-item-dates").Text(`${item.Option.Name || ""}`),
                        dates && new Div("basket-cart-item-dates").Text(`${dates}`),
                        new Span(item.ProductSerialNumber.value || "(no product id)").WidthAuto().DisplayInline().Bold().Color("#666"),
                        item.AccessData.value && new Span("🧩").CursorPointer().MarginLeft(4)
                            .OnClick(() => new ModalWindow("Dane dostępowe", true, true, true)
                                .AddContent(new JsonViewer(JSON.parse(item.AccessData.value)))
                                .OpenWindow()
                            ),
                    )
                )
            ],
        });
    }
}


export class AdminBasketTableItemV2 extends Div
{
    constructor(x: BasketItem)
    {
        const dates = (x instanceof RentBasketItem) ? TimeUtils.FormattedRange(x.From, x.To) : "";

        super("product-item");

        this.Append(
            new Div("product-item__info").Append(
                new Image(x.ProductInfo.Picture, x.ProductInfo.Name).Class("product-item__image"),
                new Div("product-item__details").Append(
                    new Link(x.ProductInfo.Name + " / " + (x.Option.Name || "(opcja domyślna)"), x.ProductInfo.Link),
                    dates && new Paragraph("product-item__dates").Text(`Wypożyczenie ${dates}`),
                    new Text(x.ProductSerialNumber).Bold(),
                ),
            ),
            new Div("product-item__pricing").Append(
                new Paragraph("product-item__quantity").Text(`Id: ${x.Id}`).FontSize(12).Color("#ddd"), // TODO: można to jakoś poprawić
                new Paragraph("product-item__price").Text(x.TotalPrice.value + " zł"),
                new Paragraph("product-item__quantity").Text(`Ilość: ${x.Quantity.value}`),
            ),
        );
    }
}
